// React Dependencies
import React from 'react';

// External Dependencies
import { makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';

// Internal Dependencies
import Colours from '../../../../../styles/colours';
import MButton from '../../../../../components/MButton';

const useStyles = makeStyles({
  claimBtn: {
    backgroundColor: `${Colours.Gray7} !important`,
    borderRadius:    99,
    border:          '2px solid white',
    width:           'fit-content',
    minWidth:        0,
    boxShadow:       '6px 6px 15px rgba(0, 0, 0, 0.8)',
    '&:hover':       {
      boxShadow: '6px 6px 15px rgba(0, 0, 0, 0.8)',
    },
  },
  claimBtnText: {
    fontSize:                    '9.6px !important',
    whiteSpace:                  'pre-line',
    textAlign:                   'center',
    '@media (min-width: 769px)': {
      fontSize: '4px !important',
    },
    '@media (min-width: 822px)': {
      fontSize: '5.6px !important',
    },
    '@media (min-width: 1200px)': {
      fontSize: '4px !important',
    },
    '@media (min-width: 1300px)': {
      fontSize: '6.4px !important',
    },
    '@media (min-width: 1400px)': {
      fontSize: '8px !important',
    },
  },
});

const ClaimButton = (props) => {
  const classes = useStyles();
  return (
    <div className="col-8 row px-0 align-items-center">
      <div className="col-4 pr-1 pr-lg-2">
        <img alt="right-arrow" className="w-100 h-auto" src="/images/stamp-holders/white-right-arrow.png" />
      </div>
      <div className="col-8 pl-1 pl-lg-0 ">
        <MButton
          disabled={props.disabled}
          variant="contained"
          className={`px-2 px-xl-3 ${classes.claimBtn}`}
          textColour={Colours.White}
          textStyle={{
            fontWeight:      700,
            textAlign:       'center',
            lineHeight:      1,
            display:         '-webkit-box',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 3, /* Number of lines to clamp */
            overflow:        'hidden',
          }}
          text={`Tap to claim\n${!props.isProduct ? `$` : ''}${props.label} voucher`}
          textClassName={classes.claimBtnText}
          onClick={() => {}} // Need this because the app will crash when the onClick is not provided
        />
      </div>
    </div>
  );
};

ClaimButton.defaultProps = {
  isProduct: true,
  disabled:  false,
  label:     '',
};

ClaimButton.propTypes = {
  disabled:  PropTypes.bool,
  isProduct: PropTypes.bool,
  label:     PropTypes.string,
};

export default ClaimButton;
